export enum SurveyMode {
    Test = 0,
    Preview = 1,
    Normal = 2,
    Simulation = 3,
}

export function convertToSurveyMode(mode: string): SurveyMode {
    switch (mode) {
        case "test":
            return SurveyMode.Test;
        case "normal":
            return SurveyMode.Normal;
        case "simulation":
            return SurveyMode.Simulation;
        default:
            return SurveyMode.Preview;
    }
}
